<template>
  <v-container>
    <v-card>
      <v-card class="lime elevation-0 rounded-0 mb-2" dark tile>
        <v-card-title>
          <v-avatar size="48">
            <img src="@/assets/favicon.png" alt="avatar" />
          </v-avatar>
          <v-spacer></v-spacer>
          <h3 style="color:white">{{ exam_name }}</h3>
        </v-card-title>
      </v-card>
      <v-dialog v-model="otp_upload" max-width="600px" persistent>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <p>
                    <b>KNDI Professional Upgrading Online Examination</b>
                    <br /><br />
                    <b>Instructions to Candidates</b> <br /><b>I.</b> Ensure
                    that you are comfortable and ready to take a test. You must
                    not feel any unnecessary stress, either physical or mental.
                    <br /><b>II.</b>
                    You have been given 2 hours to answer all questions.
                    <br /><b>III.</b> Be accurate, do not guess, take your time
                    and make sure you thoroughly understand the question before
                    attempting to answer. <br />
                  </p>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="lime darken-1" @click="otp_upload = false"
              >Finish</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-container class="justify-center" v-if="start == false">
        <v-flex xs12 md12>
          <v-btn color="lime" class="white--text" block @click="fetchQuestion"
            >proceed to examination</v-btn
          >
        </v-flex>
      </v-container>
      <v-container v-else>
        <v-flex xs12 md12 class="mb-3">
          <h4>{{ question_number }}. {{ models.question }}</h4>
        </v-flex>
        <v-flex xs12 sm12 md12 v-if="models.diagram_link != ''">
          <v-card>
            <v-img
              :aspect-ratio="1 / 1"
              max-height="505"
              contain
              :src="models.diagram_link"
              class="grey lighten-4"
            >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular
                    indeterminate
                    color="lime"
                  ></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </v-card>
        </v-flex>
        <form>
          <v-card class="mb-5" color="grey lighten-4" height flat>
            <v-progress-linear
              :indeterminate="true"
              color="lime"
              v-if="sending"
            ></v-progress-linear>
            <v-card-text>
              <v-flex xs12 sm12 md12>
                <v-radio-group
                  v-model="user_answer"
                  :error-messages="errors.user_answer"
                >
                  <v-radio
                    v-for="a_answer in models.answers"
                    :key="a_answer"
                    :label="a_answer"
                    :value="a_answer"
                    color="lime"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-card-text>
          </v-card>
          <v-btn
            color="lime"
            class="white--text"
            @click.native="check"
            v-if="disabled == false"
            >continue</v-btn
          >
          <v-btn disabled v-if="disabled == true">
            <v-progress-circular
              :width="3"
              :size="15"
              indeterminate
              color="white"
            ></v-progress-circular
            >&nbsp; checking
          </v-btn>
        </form>
      </v-container>

      <v-dialog v-model="downloaded" persistent width="300">
        <v-card color="lime" dark>
          <v-card-text>
            Please stand by
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>
<script>
import Vue from "vue"
import {
  examPaperOnline_OpenUrl,
  examPaperOnline_TokenUrl,
  examPaperOnline_AnswerUrl //,
  //getHeader
} from "@/config"
import axios from "axios"
import swal from "sweetalert2"
export default {
  data() {
    return {
      snackbar: false,
      snackbar_text: "",
      y: "",
      x: "",
      mode: "",
      e1: 0,
      maxCount: 140,
      remainingCount: 140,
      checking: false,
      disabled: false,
      step_one: true,
      errors: {
        user_answer: "",
        otp: ""
      },
      exam_name: "",
      models: [],
      user_answer: "",
      exam_name: "",
      app_tbl_id: "",
      sending: false,
      downloaded: false,
      question_number: "",
      otp_upload: false,
      otp: "",
      photo: "",
      start: false
    }
  },
  beforeMount() {
    if (this.$route.params.token != "") {
      this.fetchData()
      this.downloaded = true
      this.otp_upload = true
      clearInterval(window.setIntervalSecurityCheck)
    } else {
      swal({
        title: "Unauthorized",
        text: "You are not authorized to use this service",
        type: "warning",
        confirmButtonColor: "#cddc39",
        confirmButtonText: "OK"
      })
      this.$router.push({ name: "register" })
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!window.setIntervalConfirm) {
      next()
    } else {
      clearInterval(setIntervalConfirm)
      next()
    }
  },
  /*mounted() {
      var counter = 0
      var vm = this
      window.setIntervalConfirm = setInterval(function() {
        counter += 1
  
        if (vm.exam_name == "") {
          vm.fetchData()
        }
  
        if (counter === 3) {
          clearInterval(setIntervalConfirm)
        }
      }, 20000)
    },*/
  methods: {
    fetchData() {
      var vm = this
      var data = {
        token: vm.$route.params.token
      }
      const options = {
        method: "POST",
        //headers: getHeader(),
        data: data,
        url: examPaperOnline_OpenUrl
      }
      axios(options)
        .then(function(response) {
          Vue.set(vm.$data, "exam_name", response.data.exam_name)
          if (response.data.start) {
            //vm.fetchQuestion()
            vm.downloaded = false
            vm.disabled = false
          }
          if (response.data.no_exam) {
            vm.downloaded = false
            vm.disabled = false
            swal({
              title: "Attention",
              text: "There are currently No Examinations matching this token.",
              type: "info",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })

            vm.$router.push({ name: "upgrading-examination-register" })
          }
          if (response.data.not_active) {
            vm.downloaded = false
            vm.disabled = false
            swal({
              title: "Attention",
              text: "This professional examination is currently not active.",
              type: "info",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })

            vm.$router.push({ name: "upgrading-examination-register" })
          }
          if (response.data.no_exam) {
            vm.downloaded = false
            vm.disabled = false
            swal({
              title: "Attention",
              text: "There are currently No Examinations matching this token.",
              type: "info",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })

            vm.$router.push({ name: "upgrading-examination-register" })
          }
          if (response.data.not_exam_time) {
            vm.downloaded = false
            vm.disabled = false
            swal({
              title: "Attention",
              text:
                "This professional examination will be administered on " +
                response.data.exam_day +
                ". The Examination paper will be taken according to the time slot you choose or were allocated",
              type: "info",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })

            vm.$router.push({ name: "upgrading-examination-register" })
          }

          if (response.data.not_exam_day) {
            vm.downloaded = false
            vm.disabled = false
            swal({
              title: "Attention",
              text:
                "This professional examination will be administered on " +
                response.data.exam_day +
                ". The Examination paper will be taken according to the time slot you choose or were allocated",
              type: "info",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })

            vm.$router.push({ name: "upgrading-examination-register" })
          }

          if (response.data.unauthorized) {
            swal({
              title: "Unauthorized",
              text: "You are not authorized to use this service",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            //vm.$router.push({ name: "register" })
          }
        })
        .catch(function(error) {
          console.log(error.message)
          vm.downloaded = false
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
            vm.disabled = false
            vm.sending = false
          }
        })
    },
    fetchQuestion() {
      var vm = this
      //vm.downloaded = true
      var data = {
        token: vm.$route.params.token,
        app_tbl_id: vm.app_tbl_id,
        exam_name: vm.exam_name
      }
      const options = {
        method: "POST",
        //headers: getHeader(),
        data: data,
        url: examPaperOnline_TokenUrl
      }
      axios(options)
        .then(function(response) {
          if (response.data.model) {
            vm.downloaded = false
            vm.disabled = false
            vm.sending = false
            Vue.set(vm.$data, "models", response.data.model)
            Vue.set(vm.$data, "exam_name", response.data.exam_name)
            Vue.set(vm.$data, "question_number", response.data.question_id)
            Vue.set(vm.$data, "app_tbl_id", response.data.app_tbl_id)
            vm.start = true
          }
          if (response.data.finished) {
            vm.downloaded = false
            vm.disabled = false
            swal({
              title: "Finished",
              text:
                "You have completed the examination successfully. You have scored " +
                response.data.marks +
                " marks out of a possible " +
                response.data.final_marks +
                " marks.",
              type: "success",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.$router.push({ name: "upgrading-examination-register" })
          }

          if (response.data.not_active) {
            vm.downloaded = false
            vm.disabled = false
            swal({
              title: "Attention",
              text:
                "This Examination is not yet available. Once your exam starts it can't be stopped or postponed.",
              type: "info",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            //vm.$router.push({ name: "upgrading-examination-register" })
          }
          if (response.data.not_active_time) {
            swal({
              title: "Attention",
              text:
                "You have run out of time. Your examination progress has been saved. Your examination paper results will be provided three working days after the last professional examination paper.",
              type: "info",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            //vm.$router.push({ name: "upgrading-examination-register" })
          }
          if (response.data.unauthorized) {
            swal({
              title: "Unauthorized",
              text: "You are not authorized to use this service",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            //vm.$router.push({ name: "register" })
          }
        })
        .catch(function(error) {
          console.log(error.message)
          vm.disabled = false
          vm.sending = false
          vm.downloaded = false
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
            vm.disabled = false
            vm.sending = false
          }
        })
    },
    check() {
      var vm = this
      if (vm.user_answer == "") {
        vm.errors.user_answer = "Please choose your answer before proceeding."
      } else {
        vm.errors.user_answer = ""
        vm.submit()
      }
    },
    submit() {
      var vm = this
      vm.disabled = true
      vm.sending = true

      const data = {
        token: vm.$route.params.token,
        answer: vm.user_answer,
        question_id: vm.models.id
      }

      const options = {
        method: "POST",
        //headers: getHeader(),
        data: data,
        url: examPaperOnline_AnswerUrl
      }

      axios(options)
        .then(function(response) {
          if (response.data.saved) {
            vm.fetchQuestion()
            //vm.disabled = false
            //vm.sending = false
            vm.user_answer = ""
          }
          if (response.data.not_active_time) {
            swal({
              title: "Attention",
              text:
                "You have run out of time. Your examination progress has been saved. Your examination paper results will be provided three working days after the last professional examination paper.",
              type: "info",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.disabled = false
            vm.sending = false
            vm.downloaded = false
            vm.$router.push({ name: "upgrading-examination-register" })
          }
        })
        .catch(function(error) {
          console.log(error)
          Vue.set(vm.$data, "errors", error.response.data)
          vm.disabled = false
          vm.downloaded = false
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
            vm.disabled = false
            vm.sending = false
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/upgrading-exam-online-paper-active.vue